import React, { Component } from 'react';
import Icon from '../components/Icon';
import TwitterShareButton from '../components/TwitterShareButton';
import FacebookUIShare from '../components/FacebookUIShare';
import Mailto from 'react-mailto';

class SharingPage extends Component {
    constructor(props){
        super(props);

        this.state = {
            shareResult:false,
            shareGame:false
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleShareGame = this.handleShareGame.bind(this);
        this.handleShareResult = this.handleShareResult.bind(this);
    }

    handleClose(){
        this.setState({
            shareResult:false,
            shareGame:false
        });
    }

    handleShareGame(evt){
        this.setState({
            shareResult:false,
            shareGame:true
        });

    }

    handleShareResult(evt){
        this.setState({
            shareResult:true,
            shareGame:false
        });

    }

    renderShareResult(){
        if(this.props.winners.length > 0) {

            var url = window.location.href;
            var fbUrl = url + '?winner=' + this.props.winners[0].id;

            var subject = "";
            if(this.props.siteLabel != ''){
                subject = "Avec " + this.props.siteLabel + ", participe";
            }else{
                subject = "Participe";
            }
            subject += " au jeu \"" + this.props.gameTitle + "\"";
            if(this.props.partenaire != ''){
                subject += " " + this.props.partenaire;
            }
            subject += " !";

            var body = subject + " J'ai tenté l'expérience, et ai découvert que le profil " + this.props.winners[0].label + " me correspondait le mieux. >> ";
            body += url;

            var fbSubject = "";
            if(this.props.siteLabel != '') {
                fbSubject = "Avec " + this.props.siteLabel + ", participez";
            }else{
                fbSubject = "Participez";
            }
            fbSubject += " au Serious Game";
            if(this.props.partenaire != ''){
                fbSubject += " " + this.props.partenaire;
            }
            var fbBody = "J'ai tenté l'expérience \"" + this.props.gameTitle + "\" et ai découvert que le profil " + this.props.winners[0].label + " me correspondait le mieux";

            var tweetBody = "Participe au jeu \"" + this.props.gameTitle + "\" > ";

            var fbImage = this.props.imgAccueil;

            return (
                <div className="isg_sharebox">
                    <div className="isg_share_close" onClick={this.handleClose}>
                        <Icon value="icon_close" />
                    </div>

                    <FacebookUIShare
                        url={fbUrl}
                        title={fbSubject}
                        description={fbBody}
                        image={fbImage}
                    >
                    <Icon value="icon_fb" />
                    </FacebookUIShare>

                    <TwitterShareButton
                        url={this.props.shorturl}
                        title={tweetBody}
                        via={this.props.twitterAccount}
                    >
                        <Icon value="icon_tweet" />
                    </TwitterShareButton>

                    <Mailto
                        className="isg_share_button"
                        email={""}
                        headers={{
                            subject:subject,
                            body:body
                        }}>
                        <Icon value="icon_mail" />
                    </Mailto>
                </div>
            );
        }else{
            return this.renderShareGame();
        }
    }

    renderShareGame(){

        var url = window.location.href;
        var subject = "";
        if(this.props.siteLabel != '') {
            subject = "Avec " + this.props.siteLabel + ", participe";
        }else{
            subject = "Participe";
        }
        subject += " au jeu \"" + this.props.gameTitle + "\"";
        if(this.props.partenaire != ''){
            subject += " " + this.props.partenaire;
        }
        subject += " !";
        
        var tweetBody = "Participe au jeu \"" + this.props.gameTitle + "\"" + " > ";
        var body = subject + " >> " + url;

        var fbImage = this.props.imgAccueil;

        var fbSubject = "";
        if(this.props.siteLabel != ""){
            fbSubject = "Avec " + this.props.siteLabel + ", participez";
        }else{
            fbSubject = "Participez";
        }
        fbSubject += " au Serious Game";
        if(this.props.partenaire != ''){
            fbSubject += " " + this.props.partenaire;
        }
        var fbBody = "Tentez l'expérience \"" + this.props.gameTitle + "\"";

        return(
            <div className="isg_sharebox">
                <div className="isg_share_close" onClick={this.handleClose}>
                    <Icon value="icon_close" />
                </div>

                <FacebookUIShare
                    url={url}
                    title={fbSubject}
                    description={fbBody}
                    image={fbImage}
                >
                    <Icon value="icon_fb" />
                </FacebookUIShare>

                <TwitterShareButton
                    url={this.props.shorturl}
                    via={this.props.twitterAccount}
                    title={tweetBody}
                >
                    <Icon value="icon_tweet" />
                </TwitterShareButton>

                <Mailto
                    className="isg_share_button"
                    email={""}
                    headers={{
                            subject:subject,
                            body:body
                        }}>
                    <Icon value="icon_mail" />
                </Mailto>

            </div>
        );
    }

    _getLogoWithBanner(){
        return (
            <div className="isg_logo">
                <img src={this.props.imgBanner} alt="" />
            </div>
    );
    }

    _getLogoWithoutBanner(){
        return (
            <div className="isg_logo"></div>
    );
    }

    renderContent()
    {

        return (
            <div>
                <div className="isg_sharing_title">Surpris du résultat ?</div>
                <p>Invitez vos amis à participer&nbsp;!</p>
                <button className="isg_btn" onClick={this.handleShareGame}>Proposez leur de jouer !</button>
                {this.props.winners.length > 0 ? <button className="isg_btn isg_margin_top" onClick={this.handleShareResult}>Partagez votre résultat</button> : ''}
                <div className="isg_bottom_box">
                    <div className="isg_panel_content">
                        <span onClick={this.props.handleGoBackToResult}>
                            <Icon value="icon_retour" /> Mon résultat
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    render(){
        var banner = '';
        if(this.props.imgBanner !== ''){
            banner = this._getLogoWithBanner();
        }else{
            banner = this._getLogoWithoutBanner();
        }

        return(
            <div className="isg_panel isg_sharing_page isg_bg_base">
                {banner}
                <div className="isg_panel_content">
                    {this.state.shareGame ? this.renderShareGame() : this.state.shareResult ? this.renderShareResult() : this.renderContent()}
                </div>
            </div>
        );
    }
}

SharingPage.propTypes = {
    handleRestart: React.PropTypes.func.isRequired,
    handleGoBackToResult: React.PropTypes.func.isRequired,
    winners: React.PropTypes.array.isRequired,
    imgBanner: React.PropTypes.string,
    imgAccueil: React.PropTypes.string,
    partenaire: React.PropTypes.string,
    gameTitle: React.PropTypes.string.isRequired,
    shorturl: React.PropTypes.string.isRequired,
    siteLabel: React.PropTypes.string,
    twitterAccount: React.PropTypes.string
};

export default SharingPage;


/** WEBPACK FOOTER **
 ** ./src/components/SharingPage.js
 **/